webpackJsonp([213130420965792],{

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.postQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(57);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Grid = __webpack_require__(34);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Paper = __webpack_require__(49);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Typography = __webpack_require__(35);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(29);
	
	var _Container = __webpack_require__(65);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    sidebarBlog: {
	      padding: '1rem',
	      backgroundColor: theme.palette.grey[100]
	    },
	    blogHomeLink: {
	      marginTop: '2rem'
	    }
	  };
	};
	
	var Post = function Post(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	  var post = data.markdownRemark;
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    { container: true },
	    _react2.default.createElement(
	      _Grid2.default,
	      { item: true, xs: 12 },
	      _react2.default.createElement(
	        _Container2.default,
	        { flex: true },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 8 },
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'display1' },
	            post.frontmatter.title
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'body1' },
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: post.html } })
	          )
	        ),
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 4 },
	          _react2.default.createElement(
	            _Paper2.default,
	            { className: classes.sidebarBlog },
	            _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'headline' },
	              'Recent Articles'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              data.allMarkdownRemark.edges.map(function (_ref2) {
	                var node = _ref2.node;
	                return _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _Typography2.default,
	                    { variant: 'body2' },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { key: node.id, to: node.frontmatter.path },
	                      node.frontmatter.title
	                    )
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true, className: classes.blogHomeLink },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 12 },
	            _react2.default.createElement('hr', null),
	            _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'body1' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/blog' },
	                'Go back to articles main page'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _styles.withStyles)(styles)(Post);
	var postQuery = exports.postQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-post-jsx-930f612eaa0ff3298a95.js